import React from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { FDBreadcrumbs } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';

export const HouseholdProfileBreadcrumbs = ({ resource, onClickBreadcrumb }) => {
  const breadcrumbs = React.useMemo(() => {
    return resource.withRelationship(fr.relationships.householdMembershipPage.name, (rel) => {
      return [
        { label: rel.meta('prompt'), onClick: () => onClickBreadcrumb(rel.link('related')) },
        { label: resource.attr('breadcrumb'), onClick: () => onClickBreadcrumb(resource.link('self')) },
      ];
    }, () => {
      return [
        { label: resource.attr('breadcrumb'), onClick: () => onClickBreadcrumb(resource.link('self')) },
      ];
    });
  }, [resource]);
  return (
    <FDBreadcrumbs {...dataAttrs('breadcrumb', resource)} breadcrumbs={breadcrumbs} />
  );
};

HouseholdProfileBreadcrumbs.propTypes = {
  resource: PropTypes.object.isRequired,
  onClickBreadcrumb: PropTypes.func.isRequired,
};
